import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  sectionHighlightsBadge: {
    id: 'course-authoring.course-outline.section.badge.section-highlights',
    defaultMessage: 'Section highlights',
  },
});

export default messages;
